import dayjs from "dayjs";
import frLocale from "dayjs/locale/fr";
import { classNames } from "../../../../utils";
import Timer from "../../../../uikit/Timer/Timer";
import { useTranslation } from "react-i18next";
import { GetGameResponse } from "../../../../api/types";
import { TeamLogo } from "../../../../components/S3Image";

dayjs.locale(frLocale);

interface GameItemProps {
  game: GetGameResponse;
  onClick: () => void;
}

const isTeamIsWinner = (game: GetGameResponse, team?: string) => {
  if (game.status === "done" || game.status === "live") {
    if (game.home_score == null || game.away_score == null) {
      return false;
    }
    if (game.home_team?.name === team) {
      return game.home_score > game.away_score;
    } else {
      return game.away_score > game.home_score;
    }
  }
  return false;
};

const GameItem = ({ game, onClick }: GameItemProps) => {
  const { t } = useTranslation();
  return (
    <tr onClick={onClick} className="cursor-pointer">
      <td className="whitespace-nowrap py-5 pl-4 pr-3 text-sm sm:pl-6">
        {/* <div className={"truncate font-light text-gray-500 pb-1"}>
          {game.home_team?.name || game.home_team_placeholder} vs {game.away_team?.name || game.away_team_placeholder}
        </div> */}
        <div className="flex items-center">
          <div className="flex-shrink-0 md:flex md:flex-row gap-1">
            {game.home_team?.logo_key ? (
              <TeamLogo
                className="w-6 h-6 md:w-8 md:h-8 lg:w-10 lg:h-10 rounded object-contain pr-1"
                keyPath={game.home_team?.logo_key}
                alt=""
              />
            ) : (
              <div className="w-6 h-6 md:w-8 md:h-8 lg:w-10 lg:h-10 rounded-full object-contain pr-1 bg-gray-100" />
            )}
            {game.away_team?.logo_key ? (
              <TeamLogo
                className="w-6 h-6 md:w-8 md:h-8 lg:w-10 lg:h-10 rounded object-contain"
                keyPath={game.away_team?.logo_key}
                alt=""
              />
            ) : (
              <div className="w-6 h-6 md:w-8 md:h-8 lg:w-10 lg:h-10 rounded-full object-contain bg-gray-100" />
            )}
          </div>
          <div className="ml-4">
            <div
              className={classNames(
                "truncate font-bold",
                isTeamIsWinner(game, game.home_team?.name)
                  ? "text-blue-600"
                  : "text-gray-500"
              )}
            >
              {game.home_team?.name || game.home_team_placeholder}
            </div>
            <div
              className={classNames(
                "truncate font-bold",
                isTeamIsWinner(game, game.away_team?.name)
                  ? "text-blue-600"
                  : "text-gray-500"
              )}
            >
              {game.away_team?.name || game.away_team_placeholder}
            </div>
          </div>
        </div>
      </td>
      <td className="whitespace-nowrap px-3  text-sm text-gray-500">
        <div className="flex flex-row">
          <span
            className={classNames(
              "inline-flex rounded-full px-2 text-xs font-semibold leading-5 text-green-800",
              game.status === "done" ? "bg-green-100" : "bg-gray-100",
              game.status === "live"
                ? "bg-red-200 animate-pulse"
                : "bg-gray-100"
            )}
          >
            {t(`games:status:${game.status}`)}
          </span>
          {game.status === "live" && game.start_time && (
            <Timer
              startDateTime={game?.start_time}
              // @TODO: Remove this
              isSecondHalfPlaying={false}
            />
          )}
        </div>
        {game.status === "upcoming" && (
          <p>{dayjs(game.date).format("ddd DD MMM HH:mm")}</p>
        )}
        <p>{game.field?.name}</p>
      </td>
      {game.status !== "upcoming" && (
        <td className="relative whitespace-nowrap  pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
          <td className="whitespace-nowrap px-3  text-sm">
            <dd
              className={classNames(
                "mt-1 text-2xl font-semibold tracking-tight ",
                isTeamIsWinner(game, game.home_team?.name)
                  ? "text-blue-600"
                  : "text-gray-500"
              )}
            >
              {game.home_score}
            </dd>
            <dd
              className={classNames(
                "-mt-1 text-xl font-semibold tracking-tight ",
                isTeamIsWinner(game, game.away_team?.name)
                  ? "text-3xl text-blue-600"
                  : "text-2xl text-gray-500"
              )}
            >
              {game.away_score}
            </dd>
          </td>
        </td>
      )}
    </tr>
  );
};

export default GameItem;
